module.exports = __webpack_public_path__ + "cd905ccda68192317bdea7fc3eb1c1c6.jpg";